export var mailboxesRelativePath = "/mailboxes";
export var createMailboxesApi = function (baseUrl, http) {
    var apiUrl = "" + baseUrl + mailboxesRelativePath;
    return {
        getMailboxes: function () { return http.get(apiUrl); },
        addMailbox: function (dto) {
            return http.post(apiUrl, dto);
        },
        updateMailbox: function (dto) {
            return http.put(apiUrl + "/" + dto.id, { forwardingAddress: dto.forwardingAddress });
        },
        deleteMailbox: function (dto) { return http.delete(apiUrl + "/" + dto.id); },
        setDefaultMailbox: function (dto) { return http.put(apiUrl + "/" + dto.id + "/setDefault", {}); }
    };
};
//# sourceMappingURL=index.js.map